module.exports = __webpack_public_path__ + "static/media/user.e00bd929.svg";